import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { Description } from 'components/Typography'
import { NavButton } from 'components/Button'

const ScheduleDeleteCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/delete.svg'} alt={'事前予約日設定を削除しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          事前予約日設定を
          <br />
          削除しました
        </h2>
        <Spacer size={12} />
        <Description
          align={'center'}
          description={'sacriを立ち上げて、対象の商品が事前予約の受付ができなくなっていることを確認してください。'}
        />
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'事前予約日設定に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/schedule'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ScheduleDeleteCompleteTemplate
